import { render, staticRenderFns } from "./DialogCreateMADTemplate.vue?vue&type=template&id=0d96dc96&scoped=true"
import script from "./DialogCreateMADTemplate.vue?vue&type=script&lang=js"
export * from "./DialogCreateMADTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d96dc96",
  null
  
)

export default component.exports